<template>
  <div class="student-report">
    <Forbidden v-if="getUserRole[getUserRole.length - 1].role_id == 0" routerPath="notLogin" />
    <Forbidden
      v-else-if="
      !getHasProgramRegistered || 
      getUserRole[getUserRole.length - 1].role_id != userRole.STUDENT"
      routerPath="incorrectRole"
    />
    <section v-else class="student-report vector-background">
      <b-row class="text-center">
        <b-col>
          <h2>Laporan Penilaian</h2>
        </b-col>
      </b-row>
      <b-row class="table-container">
        <b-form-select
          v-model="selected"
          @change="getCurrentTerm()"
          :options="options"
          value-field="id"
          text-field="name"
          required
        >
          <template v-slot:first>
            <b-form-select-option :value="null" disabled>Pilih Term</b-form-select-option>
          </template>
        </b-form-select>
        <b-table
          responsive
          hover
          borderless
          :items="studentReports"
          :fields="fields"
          thead-class="custom-header"
        ></b-table>
      </b-row>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import User from "@/services/User";
import moment from "moment";
import Forbidden from "@/views/Forbidden.vue";
import { UserRole } from "@/services/StatusCode";

export default {
  name: "StudentReport",
  components: {
    Forbidden
  },
  data() {
    return {
      selected: "",
      options: [],
      fields: [
        {
          key: "date",
          label: "Tanggal (yyyy/mm/dd)",
          sortable: true
        },
        {
          key: "juz",
          label: "Juz",
          sortable: true
        },
        {
          key: "surah",
          label: "Surat/Ayat",
          sortable: false
        },
        {
          key: "score",
          label: "Nilai",
          sortable: false
        },
        {
          key: "note",
          label: "Catatan",
          sortable: false
        }
      ],
      studentReports: [],
      tempReports: [],
      userRole: UserRole
    };
  },
  methods: {
    async getUserStudentReports(selectedTerm) {
      await User.getStudentReports(
        process.env.VUE_APP_URL,
        selectedTerm,
        this.getAccessToken
      ).then(response => {
        this.tempReports = response.reports;
        this.tempReports.forEach(eachDate => {
          eachDate.date = moment(eachDate.date, "DD MMM YYYY").format(
            "YYYY/MM/DD"
          );
        });
        this.studentReports = this.tempReports;
      });
    },
    async getTermList() {
      await User.getAllTerm(process.env.VUE_APP_URL).then(response => {
        this.options = response;
      });
    },
    getCurrentTerm() {
      this.getUserStudentReports(this.selected);
    }
  },
  created() {
    this.getTermList();
  },
  computed: {
    ...mapGetters({
      getTermName: "getTermName",
      getAccessToken: "getAccessToken",
      getUserRole: "getUserRole",
      getSchedulePeriodOpened: "getSchedulePeriodOpened",
      getHasProgramRegistered: "getHasProgramRegistered"
    })
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/reusable/table.scss";

.student-report {
  min-height: inherit;
}

h2 {
  padding-top: 5%;
}

.table-container {
  min-width: 10%;
  padding-top: 5%;
  padding-left: 10%;
  padding-right: 10%;
}

.custom-header {
  border-bottom: 2px solid #40bfc1;
}
</style>